
const EPaymentMode = {
  AMERICAN_EXPRESS: 1,

  VISA: 2,

  MASTERCARD: 4,

  CASH: 8,

  RESTAURANT_TICKET: 16
}

export default EPaymentMode;
